import React from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import useTrackEvent from '../../utils/trackEvent';
import type { Product as ProductType } from '../../types/product';

interface Props {
  product: ProductType;
}

const ProductNew = ({ product }: Props) => {
  const trackEvent = useTrackEvent();
  const url = window.customer?.library_endpoint ?? import.meta.env.VITE_LIBRARY_ENDPOINT;
  const disableBuy = window.customer?.disable_buy_button ?? false;

  if (!product) return <p>Geen producten.</p>;

  const isApp = product.categories?.map((c) => c?.slug).includes('apps');
  const buyHref = disableBuy ? '#' : `https://www.thuisleefgids.nl/?puid=${product.uuid}`;
  const buyClass = (disableBuy ? 'btn-disabled ' : '') + 'btn-sm btn-primary';

  return (
    <div className="border-2 border-solid border-[rgba(249,235,242,1)] hover:border-[rgba(139,37,96,1)] hover:shadow-lg p-6 flex flex-col md:flex-row bg-white rounded-2xl min-h-[200px] gap-6">
      <div className="flex-none h-[154px] w-[154px] overflow-hidden rounded-lg mx-auto md:mx-0">
        <img
          src={product.featured_image ?? '/assets/images/product-placeholder.png'}
          alt={product.name}
          className="h-full w-full object-cover sm:h-[154px] sm:w-[154px]"
        />
      </div>
      <div className="flex-1 flex flex-col gap-1">
        <div className="flex flex-wrap items-start gap-4">
          <span className="font-bold text-lg">{product.name}</span>
          {product.isCompensated && (
            <span className="font-semibold text-sm inline-flex gap-2 items-center rounded-full py-1 px-2.5 border-2 border-secondary-orange text-secondary-orange">
              <i className="fa-solid fa-check" />
              Vergoed
            </span>
          )}
        </div>
        <div className="overflow-hidden text-ellipsis line-clamp-4">
          {product.short_description ? (
            <div>{parse(product.short_description)}</div>
          ) : product.description ? (
            <div>{parse(product.description.replace(/<h[1-6][^>]*>.*?<\/h[1-6]>/g, '').split('\n').slice(0, 3).join('\n'))}</div>
          ) : null}
        </div>
      </div>
      <div className="pl-5 sm:pl-0 flex flex-wrap items-start gap-2.5">
        {product.exists ? (
          <Link to={`${url}?puid=${product.uuid}`} className="btn-sm btn-primary" target="_blank"
            onClick={() => trackEvent('Click_ViewProductBieb', { select: product.name, product_id: product.id, product_uuid: product.uuid })}>
            {isApp ? 'Download app' : 'Lenen'}
          </Link>
        ) : (
          <Link to={buyHref} className={buyClass} target="_blank"
            onClick={() => trackEvent('Click_ViewProductGids', { select: product.name, product_id: product.id, product_uuid: product.uuid })}>
            Product bekijken
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProductNew;
